import React, { useEffect, useState } from 'react';
import PlacedBetLine from '../BetLines/PlacedBetLine';
import { useDispatch, useSelector } from 'react-redux';
import { BET_SLIP_PLACED_TICKET_CHANGED } from '../../../store/actions/types';
import { formatMessage, getTranslation } from '../../../utils/translation';
import styles from './PlacedTicket.module.scss';
import commonStyles from '../BetSlip.module.scss';

const PlacedTicket = props => {
    const dispatch = useDispatch();
    const placedTicketDetails = useSelector(state => state.betSlip.placedTicketDetails);
    const betLines = useSelector(state => state.betSlip.betLines);
    const [timer, setTimer] = useState(null);
    const [timerValue, setTimerValue] = useState(10);

    const { resetBetSlip } = props;

    useEffect(() => {
        if (placedTicketDetails) {
            const interval = setInterval(() => {
                setTimerValue(value => value - 1);
            }, 1000);
            setTimer(interval);
        }
    }, [placedTicketDetails]);

    useEffect(() => {
        if (timerValue === 0) {
            resetPlacedTicket();
            resetBetSlip();
        }
    }, [timerValue]);

    useEffect(() => {
        if (!betLines.length && timer) {
            clearInterval(timer);
            setTimer(null);
            setTimerValue(10);
        }
    }, [betLines]);

    const onRetainSelections = () => {
        resetPlacedTicket();
    };

    const onClearTicketResult = () => {
        resetPlacedTicket();
        resetBetSlip();
    };

    const resetPlacedTicket = () => {
        dispatch({
            type: BET_SLIP_PLACED_TICKET_CHANGED,
            payload: null,
        });
        clearInterval(timer);
        setTimer(null);
        setTimerValue(10);
    };

    return (
        <div className={commonStyles.betSlipWrap}>
            <div className={commonStyles.betSlipBody}>
                <div className={styles.placeBetSuccess}>
                    <div className={styles.iconSuccessWrap}>
                        <i className='icon-success' />
                    </div>
                    <p className={styles.successMessage}>{getTranslation('betSlip.placeBets.successMessage')}</p>
                    <p className={styles.successDetails}>
                        <span>
                            {getTranslation('betSlip.placeBets.betId')}
                            {': '}
                        </span>
                        <span>{placedTicketDetails.ticketId}</span>
                    </p>
                    {/*<p className={styles.successDetails}>*/}
                    {/*    <span>*/}
                    {/*        {getTranslation('betSlip.placeBets.ticketNumber')}*/}
                    {/*        {': '}*/}
                    {/*    </span>*/}
                    {/*    <span>{placedTicketDetails.ticketNumber}</span>*/}
                    {/*</p>*/}
                    <p className={styles.successDetails}>
                        <span>
                            {placedTicketDetails.events.length === 1
                                ? formatMessage(getTranslation('betSlipPlacedTicketFoldCount'), {
                                      count: placedTicketDetails.events.length,
                                  })
                                : formatMessage(getTranslation('betSlipPlacedTicketFoldsCount'), {
                                      count: placedTicketDetails.events.length,
                                  })}
                            -
                            {placedTicketDetails.betCount === 1
                                ? formatMessage(getTranslation('betSlipPlacedTicketBetCount'), {
                                      count: placedTicketDetails.betCount,
                                  })
                                : formatMessage(getTranslation('betSlipPlacedTicketBetsCount'), {
                                      count: placedTicketDetails.betCount,
                                  })}
                        </span>
                    </p>

                    <p className={styles.successDetails}>
                        <span>Stake = {placedTicketDetails.result.cost.value}</span>
                    </p>
                    <p className={styles.successDetails}>
                        <span>
                            {getTranslation('betSlip.placeBets.winTax')} (10%) ={' '}
                            {placedTicketDetails.result.winningTax.value}
                        </span>
                    </p>
                    {placedTicketDetails.result.toBonus?.value ? (
                        <p className={styles.successDetails}>
                            <span>
                                {getTranslation('betSlip.placeBets.bonus')}
                                {' = '}
                                {placedTicketDetails.result.toBonus.value}
                            </span>
                        </p>
                    ) : null}
                    <p className={styles.successDetails}>
                        <span>
                            {getTranslation('betSlip.placeBets.potentialPayout')}
                            {' = '}
                            <span className={styles.green}>{placedTicketDetails.result.toPay.value}</span>
                        </span>
                    </p>
                </div>

                {placedTicketDetails.events.length > 0
                    ? placedTicketDetails.events.map(bet => (
                          <PlacedBetLine key={bet.programCode + bet.marketName + bet.outcomeName} bet={bet} />
                      ))
                    : null}
            </div>

            {placedTicketDetails && (
                <div className={`${commonStyles.betSlipAction} d-block`}>
                    <p style={{ textAlign: 'center', marginBottom: '20px' }}>
                        {getTranslation('betSlip.placeBets.windowWillClose')} - {timerValue}
                    </p>
                    <div className='flex justify-center'>
                        <button
                            className={`${commonStyles.betSlipButton} ${commonStyles.green} m-r-3`}
                            style={{
                                width: '180px',
                            }}
                            disabled={false}
                            onClick={onRetainSelections}
                        >
                            {getTranslation('betSlip.actions.retainSelections')}
                        </button>
                        <button
                            className={commonStyles.betSlipButton}
                            style={{
                                width: '116px',
                            }}
                            onClick={onClearTicketResult}
                        >
                            {getTranslation('betSlip.actions.clear')}
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PlacedTicket;
